module.exports = __webpack_public_path__ + "static/Graphik-Light-Web-4a3b9597666db9ecedff2779d3334a5c.woff";